import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { NumberDisplayList, StationCard, NewButton, PenList } from "../..";
import { css } from "../../../Styles";
import { StationInfo } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";
import { System, Location, Graph_QL } from "../../../Services";
import { useAppSelector } from "../../../Store";
import { NewProgressCicle } from "../../_Components";
import { ListTypes } from "../../BaseComponents/Animals/penList";

interface sectionModal_Props {
  system: System;
  onStationSelected?: (stationId: number) => void;
  pen: Location[],
  stations: StationInfo[]
  connect: {
    farm: string
    domain: string
    connection: Graph_QL.Connection
  }
}

export default function EsfSectionModal({pen, onStationSelected, connect, stations, system }:sectionModal_Props) {
  const { t } = useTranslation()
  const [currentFeedview, setCurrentFeedview] = useState<"ANIMALS" | "STATIONS">("STATIONS");

  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const { domain, connection } = useMemo(() => {
    let domain = Graph_QL.ObjToString({ domain: farm });
    let connection = Graph_QL.create({ domain: farm })
    return { domain, connection };
  }, [farm]);

    const progressCircles = useMemo(() => {
      return ( <div style={{display: "flex"}}>
        <NewProgressCicle animals={[]} connect={connect} circleId={1} />
        <NewProgressCicle animals={[]} connect={connect} circleId={4} />
      </div> )
    }, [connect]);

  // NumberDisplayList: Currently in this section TODO
  const FeedCorrections: JSX.Element = useMemo(() => {
    return (
      <NumberDisplayList
        height="64px"
        gridRows="1fr"
        units={[ "Stations", "Animals" ]}
        values={[ 0, 0 ]}
        header={"Currently in this section"}
      />
    )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  const StationClick = (stationId: number) => {
    if (onStationSelected) {
      onStationSelected(stationId);
    }
  }
  // #endregion

  // #region | Feed View State Router
  const FeedviewStateRouter = () => {
    switch (currentFeedview) {
      case "ANIMALS":
        return (
          <div style={{ }}>
            <PenList listType={ListTypes.pens} headerPen={true} systemType={system.fk_system_types} pens={pen} connect={{connection: connection, farm: farm, domain: domain}}/>
          </div>
        );
      case "STATIONS":
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            {stations.map((station) => 
              <StationCard key={station.station_id} station={station} onClick={() => StationClick(station.station_id)}/>
            )}
          </div>
        );
      default:
        return null;
    }
  }
  // #endregion
  
  return (<>
    <div style={{ ...css.modalTop, width: "655px" }}>
      {progressCircles}
      <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "100%"}}>
        {FeedCorrections}
        <NewButton
          content={ currentFeedview === "STATIONS" ? t("animals", { defaultValue: "view section animals" }) : t("stations", {defaultValue: "view section stations"})}
          onClick={() => { currentFeedview === "STATIONS" ? setCurrentFeedview("ANIMALS") : setCurrentFeedview("STATIONS") }}
          overrides={{
            baseStyles: {width: "250px"}
          }}
        />
      </div>
    </div>
    <div style={{ ...css.seperatorLine, width: "735px" }} />
    {FeedviewStateRouter()}
  </>)
}